import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';

const GetMeetPotentialMatchedPersonsData = (meetId, firstName, lastName, birthDate, lscCode, clubCode, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const meetIdForUrl = meetId ? encodeURIComponent(meetId) : 'NaN';
    const url = `/Meet/${meetIdForUrl}/TimesUpload/PotentialMatchedPersons?firstName=${firstName}&lastName=${lastName}&birthDate=${birthDate}&lscCode=${lscCode}&clubCode=${clubCode}`
    MeetHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData: arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetMeetPotentialMatchedPersonsData;